"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * <mm-code>
 * 본문 속 컴포넌트 이름, 속성, 토큰처럼 코드로 읽어야 하는 짧은 조각입니다.
 * 여러 줄 스니펫은 mm-code-block을 사용합니다.
 */
let Code = class Code extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <code><slot></slot></code>
    `;
    }
};
Code.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: inline-block;
      }

      code {
        display: inline-flex;
        align-items: center;
        height: 20px;
        padding: 0 var(--space-1);
        border: var(--border);
        border-radius: var(--radius);
        box-sizing: border-box;
        background: var(--background-color);
        font-family: var(--font-family-code);
        font-size: var(--font-size-12);
        font-weight: var(--font-weight-bold);
        color: color-mix(in srgb, var(--foreground-danger-color) 85%, transparent);
      }
    `,
];
Code = __decorate([
    (0, decorators_js_1.customElement)('mm-code')
], Code);
exports.Code = Code;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvZGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUFpRDtBQUVqRCwrREFBeUQ7QUFFekQ7Ozs7R0FJRztBQUVJLElBQU0sSUFBSSxHQUFWLE1BQU0sSUFBSyxTQUFRLGdCQUFVO0lBeUJsQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUE1Qk0sV0FBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztLQW1CRjtDQUNGLENBQUE7QUF2QlUsSUFBSTtJQURoQixJQUFBLDZCQUFhLEVBQUMsU0FBUyxDQUFDO0dBQ1osSUFBSSxDQThCaEI7QUE5Qlksb0JBQUkifQ==